import { Badge } from 'reactstrap';
import { PageHeader } from '../../components/PageHeader';
import { DataTable } from '../../components/DataTable';
import { useVpsNodes } from './useVpsNodes';

/**
 * #202 Proxmox-VPS-Nodes — Betreiber-Sicht, nur lesend. Jeder Node ist ein
 * Proxmox-Node mit Default-Storage/Bridge und einem Cloud-Init-Template, das
 * beim Buchen einer Kunden-VM geklont wird.
 */
export function NexusVpsNodesPage() {
  const nodes = useVpsNodes();
  const items = nodes.data?.nodes ?? [];

  return (
    <div>
      <PageHeader title="VPS-Nodes" subtitle="Proxmox-Nodes & Regionen (#202)" />

      <DataTable
        loading={nodes.isLoading}
        error={nodes.error}
        empty={!nodes.isLoading && items.length === 0}
        emptyMessage="Keine VPS-Nodes registriert."
        onRetry={() => nodes.refetch()}
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Region</th>
            <th>PVE-Node</th>
            <th>Storage</th>
            <th>Bridge</th>
            <th className="text-end">Template-VMID</th>
            <th>ISO-Storage</th>
            <th>Default</th>
            <th>Aktiv</th>
            <th>Notiz</th>
          </tr>
        </thead>
        <tbody>
          {items.map((n) => (
            <tr key={n.id}>
              <td className="small">{n.name}</td>
              <td className="small">{n.region || <span className="text-muted">—</span>}</td>
              <td className="font-monospace small">{n.pve_node}</td>
              <td className="font-monospace small">{n.storage || <span className="text-muted">—</span>}</td>
              <td className="font-monospace small">{n.bridge || <span className="text-muted">—</span>}</td>
              <td className="text-end font-monospace small">{n.template_vmid ?? <span className="text-muted">—</span>}</td>
              <td className="font-monospace small">{n.iso_storage || <span className="text-muted">—</span>}</td>
              <td>{n.is_default ? <Badge color="primary">default</Badge> : <span className="text-muted">—</span>}</td>
              <td>{n.active ? <Badge color="success">aktiv</Badge> : <Badge color="secondary">inaktiv</Badge>}</td>
              <td className="small text-muted">{n.notes || '—'}</td>
            </tr>
          ))}
        </tbody>
      </DataTable>
    </div>
  );
}
